import React, { useEffect } from 'react';
import Header from '../stepper/stepperBody/header/Header';
import './styles/SubscriptionSuccessful.scss';
import { IconCheckCircle, IconError } from 'cdk-radial';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReviewSubsSummaryCard from '../stepper/stepperBody/stepperBodyComponents/ReviewSubscriptionCard';
import  {accountConstants} from '../../constants/accountConstants'
import { updateCompleteSubscription } from '../../redux/connectedComponent/completeSubscription/completeSubscription.slice';
import { Loading } from '../loader/Loading';
import {setScreen} from '../../redux/connectedComponent/uiFactory/uiFactory.slice';
import {screens} from '../config/uiFactory.config';
import {AppSubscriptionsActivationTypes, AppSubscriptionsActivationStates} from './AppSubscriptionActivationTypeConstants';
import { sendAmplitudeData } from '../../utils/amplitude';
import { AMPLITUDE_EVENTS,AMPLITUDE_PROPERTIES } from '../../constants/amplitudeConstants';

const POSITIVE = 'positive';
const NEGATIVE = 'negative';

function SubscriptionSuccessful(props) {
  const dispatch = useDispatch();

  const solutionId =
    props.match && props.match.params && props.match.params.solutionId;
  const {
    loginDetailsSlice,
    selectDMSSlice,
    completeSubscriptionSlice,
    paymentCheckoutSlice,
    selectLocationsSlice,
    reviewSubscriptionSlice,
    solutionInfoSlice,
    privacyProtectionSlice,
    apiFieldsSlice,
    dealerApiPreferencesSlice
  } = useSelector(state => state);
  const selectedPlanId=solutionInfoSlice.selectedPlanId;

  let planId ='';
  (selectedPlanId && selectedPlanId !== '') ? planId=selectedPlanId
    : planId=props.match && props.match.params && props.match.params.selectedPlanId;

  const {
    locationsToAddForSubManagement = []
  } = selectLocationsSlice;

  const { navigatedFromSubscriptionManagement, solutionData} = props;

  const {errorInSubscription, isSubscriptionComplete, isSubscriptionPending} = completeSubscriptionSlice || {};

  const {solutionInfo, constants} = solutionInfoSlice
  const {overview} = solutionInfo;

  useEffect(() => {
  let locationsToAddForSubManagementWithCMF = selectLocationsSlice && selectLocationsSlice.locationsToAddForSubManagementWithCMF;
  let appSubscriptionActivationType = (solutionInfo && solutionInfo.app_subscriptions && solutionInfo.app_subscriptions.appSubscriptionsType) || AppSubscriptionsActivationTypes.AUTOMATIC;
  let appSubscriptionActivationState = (appSubscriptionActivationType === AppSubscriptionsActivationTypes.MANUAL) ? AppSubscriptionsActivationStates.PENDING : AppSubscriptionsActivationStates.ACTIVE;

  dispatch(
    updateCompleteSubscription({
      solutionId: navigatedFromSubscriptionManagement ? solutionData.id : solutionId,
      entityIdList: selectDMSSlice.selectedDMS && selectDMSSlice.selectedDMS.length > 0 ? selectDMSSlice.selectedDMS : (selectLocationsSlice.selectedLocationsWithCMFNumber.length ? selectLocationsSlice.selectedLocationsWithCMFNumber : locationsToAddForSubManagementWithCMF),
      status: 'subscribe',
      token: loginDetailsSlice.authenticationToken,
      decodedToken:loginDetailsSlice.decodedToken,
      planId: solutionInfo.activateOnly === false ? (navigatedFromSubscriptionManagement ? selectedPlanId : planId) : '',
      userEmail:loginDetailsSlice.userEmail,
      appName: overview.name,
      checkoutDetails: paymentCheckoutSlice.checkoutDetails ? paymentCheckoutSlice.checkoutDetails : null,
      address :  paymentCheckoutSlice.salesTaxRate ? paymentCheckoutSlice.salesTaxRate.address : null,
      tax :  paymentCheckoutSlice.salesTaxRate ? paymentCheckoutSlice.salesTaxRate.tax : null,
      checkoutType: paymentCheckoutSlice.checkoutType ? paymentCheckoutSlice.checkoutType : null,
      rShare: paymentCheckoutSlice.rShare ? paymentCheckoutSlice.rShare : null,
      userComment: reviewSubscriptionSlice.userComment ? reviewSubscriptionSlice.userComment : null,
      appSubscriptionActivationType,
      appSubscriptionActivationState,
      locations : selectLocationsSlice.selectedLocations,
      publisherName : overview.publisherName,
      firstName : loginDetailsSlice.decodedToken.firstName,
      publisherEmail : solutionInfo.subscription_notifications ? solutionInfo.subscription_notifications.email : "",
      paymentSetting:paymentCheckoutSlice.paymentSetting ? paymentCheckoutSlice.paymentSetting : null,
      emailsForSubscriptionNotifications: reviewSubscriptionSlice.emailsForSubscriptionNotifications ? reviewSubscriptionSlice.emailsForSubscriptionNotifications : [],
      activateOnly: solutionInfo.activateOnly === false ? false : true,
      privacyProtectionSupported: selectDMSSlice.privacyProtectionSupported,
      privacyProtectionOptOuts: privacyProtectionSlice.optOutsByLocation,
      editFieldSelection: apiFieldsSlice.editFieldSelection,
      dealerApiPreferences: dealerApiPreferencesSlice?.preferences || {}
    })
  );

  sendAmplitudeData(AMPLITUDE_EVENTS.COMPLETE_SUBSCRIPTION, {
    [AMPLITUDE_PROPERTIES.APP_NAME]: solutionInfo?.overview?.name,
    [AMPLITUDE_PROPERTIES.APP_ID]: solutionInfo?.id,
    [AMPLITUDE_PROPERTIES.LOCATION_COUNT]:
      selectLocationsSlice?.selectedLocationsWithCMFNumber?.length,
    [AMPLITUDE_PROPERTIES.LOCATIONS]:
      selectLocationsSlice?.selectedLocationsWithCMFNumber?.map((loc) => ({
        [AMPLITUDE_PROPERTIES.ORG_ID]: loc?.entityId,
        [AMPLITUDE_PROPERTIES.ORG_NAME]: loc?.location,
        [AMPLITUDE_PROPERTIES.ORG_CMF]: loc?.cmfNumber,
      })),
  });

  }, []);


  const notificationContentCreater = (type, numberOflocations, appName) => {
    return type === POSITIVE ?
      `You added ${numberOflocations} location(s) to your ${appName || 'app'} subscription` :
      `Failed to add ${numberOflocations} location(s) to your ${appName || 'app'} subscription`
  }

  useEffect(() => {
    if(navigatedFromSubscriptionManagement) {
      if(isSubscriptionPending) return;

      if(!errorInSubscription && isSubscriptionComplete) {
        dispatch(setScreen({
          screen: screens.SUBSCRIPTION_MANAGEMENT,
          additionalData: {
            showNotification: true,
            notificationContent: notificationContentCreater(POSITIVE, locationsToAddForSubManagement.length, overview.name),
            notificationType: POSITIVE
          }}));
          return;
      };

      if(errorInSubscription) {
        dispatch(setScreen({
          screen: screens.SUBSCRIPTION_MANAGEMENT,
          additionalData: {
            showNotification: true,
            notificationContent: notificationContentCreater(NEGATIVE, locationsToAddForSubManagement.length, overview.name),
            notificationType: NEGATIVE
          }}));
        return;
      }
    }
  }, [errorInSubscription, isSubscriptionComplete, isSubscriptionPending]);

  let isCheckoutWithAch = paymentCheckoutSlice.checkoutType === accountConstants.BANK_ACH;
  let appSubscriptionActivationType = (solutionInfo && solutionInfo.app_subscriptions && solutionInfo.app_subscriptions.appSubscriptionsType) || AppSubscriptionsActivationTypes.AUTOMATIC;
  let isAppSubscriptionActivationTypeManual = (appSubscriptionActivationType === AppSubscriptionsActivationTypes.MANUAL);

  if(navigatedFromSubscriptionManagement) {
    return <Loading />
  }
  if (!errorInSubscription && !isSubscriptionComplete) {
    return <Loading />;
  }
  else if (errorInSubscription) {
    return <div>
      <div className={'subscription-error-div'}>
        <div className={'subscription-error-text-div'}>
          <h1>Something went wrong.</h1>
          <h2>
            Please contact Fortellis Support at support@fortellis.io
          </h2>
        </div>
      </div>
    </div>
  }
  else if(isAppSubscriptionActivationTypeManual
    && !(isCheckoutWithAch && completeSubscriptionSlice.pendingAccountVerification)) {
    return (
      <>
        <div className="subscription-success-header-title">
          <IconError style={{ fill: '#074FAF', width: '75px', height: '75px' }}/>
        </div>
        <Header
          title={constants.PENDING_TITLE_FOR_APP_ACTIVATION}
          description={constants.PENDING_DESC_FOR_APP_ACTIVATION}
          className="subs-message-header"
        />
        <div className="subscription-success-container">
          <div className="subscription-success-summaryTitle">
            {constants.SUMMARY}
          </div>
          <div className="div-separator"></div>
          <div className='subscription-successful-summary-card'>
            <ReviewSubsSummaryCard />
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <div className="subscription-success-header-title">
      {isCheckoutWithAch && completeSubscriptionSlice.pendingAccountVerification ?
        <IconError style={{ fill: '#074FAF', width: '75px', height: '75px' }}/>:
        <IconCheckCircle style={{ fill: '#09AD00', width: '75px', height: '75px' }} />
      }
      </div>
      <Header
        title={isCheckoutWithAch && completeSubscriptionSlice.pendingAccountVerification ?constants.PENDING_BANK_VERIFICATION_TITLE : constants.SUCCESS_PAGE_TITLE}
        description={isCheckoutWithAch && completeSubscriptionSlice.pendingAccountVerification ?constants.PENDING_BANK_VERIFICATION_DESCRIPTION : constants.SUCCESS_PAGE_DESCRIPTION}
        className="subs-message-header"
      />
      <div className="subscription-success-container">
        <div className="subscription-success-summaryTitle">
          {constants.SUMMARY}
        </div>
        <div className="div-separator"></div>
        <div className='subscription-successful-summary-card'>
          <ReviewSubsSummaryCard />
        </div>

      </div>
      {
          isCheckoutWithAch && completeSubscriptionSlice.pendingAccountVerification ?
          <div className="ach-review-multideposit-div">
            <div className="ach-message-div">
            Please return to the Fortellis Marketplace within 1-2 days to validate the micro deposits.
            <br/>
            <br/>
            If you do not return and validate within 7 days, your subscription will be cancelled.
            </div>

          </div>:<div></div>
        }
    </>
  );
}
export default withRouter(SubscriptionSuccessful);
